const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0.01,
};

let userComeAcrossWithSection = false;

export function initVideo(components) {
  components?.forEach((component) => {
    const { banners } = component;

    banners?.forEach((banner) => {
      const videoEl = banner.querySelector('video');
      if (!videoEl) return;

      let wasPlaying = true;
      let wasMuted = true;
      const playPauseBtn = banner.querySelector('[data-video-type="video"]');
      const muteUnmuteBtn = banner.querySelector('[data-audio-type="audio"]');

      playPauseBtn.addEventListener('click', () => {
        if (playPauseBtn.dataset.state === 'playing') {
          videoEl.pause();
          playPauseBtn.dataset.state = 'paused';
        } else {
          videoEl.play();
          playPauseBtn.dataset.state = 'playing';
        }
      });

      muteUnmuteBtn.addEventListener('click', () => {
        if (muteUnmuteBtn.dataset.state === 'muted') {
          videoEl.muted = false;
          muteUnmuteBtn.dataset.state = 'unmuted';
        } else {
          videoEl.muted = true;
          muteUnmuteBtn.dataset.state = 'muted';
        }
      });

      document.addEventListener('swiper:slide:changed', () => {
        if (playPauseBtn.dataset.state === 'playing') {
          videoEl.pause();
          playPauseBtn.dataset.state = 'paused';
        } else if (
          videoEl.closest('.slider__item').classList.contains('active')
        ) {
          videoEl.play();
          playPauseBtn.dataset.state = 'playing';
        }
      });

      const observer = new IntersectionObserver((e) => {
        if (!e[0].isIntersecting) {
          if (userComeAcrossWithSection) {
            wasPlaying = !videoEl.paused;
          }
          wasMuted = videoEl.muted;

          videoEl.pause();
          playPauseBtn.dataset.state = 'paused';
          return;
        }

        videoEl.muted = wasMuted;
        userComeAcrossWithSection = true;
        if (!wasPlaying) return;

        videoEl.play();
        playPauseBtn.dataset.state = 'playing';
      }, options);
      observer.observe(videoEl);
    });
  });
}